import React from "react";
import { motion } from "framer-motion";
import {
  Home,
  UserCircle,
  QrCode,
  Calendar,
  Settings,
  Headphones,
  Music,
} from "lucide-react";
import packageJson from "../../../package.json";
const version = packageJson.version;
const menuItems = [
  { id: "home", label: "Home", icon: Home, route: "/loggedinartistbussiness" },
  { id: "qr", label: "QR Code", icon: QrCode, route: "/businessQr" },
  {
    id: "calendar",
    label: "Calendar",
    icon: Calendar,
    route: "/businessCalendar",
  },
  {
    id: "profile",
    label: "Profile",
    icon: UserCircle,
    route: "/businessProfile",
  },
];

const Sidebar = ({ currentPage, onPageChange }) => {
  // Only animate sidebar for home page
  const SidebarContent = (
    <div className="fixed left-0 top-0 h-full w-80 bg-gradient-to-b from-logo via-[#6720A3] to-[#6D2398] text-white shadow-2xl z-20 flex flex-col">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {Array.from({ length: 15 }).map((_, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full bg-white/5"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${Math.random() * 30 + 10}px`,
              height: `${Math.random() * 30 + 10}px`,
            }}
            animate={{
              y: [0, -15, 0],
              opacity: [0.2, 0.6, 0.2],
              scale: [1, 1.1, 1],
            }}
            transition={{
              duration: 4 + Math.random() * 2,
              repeat: Number.POSITIVE_INFINITY,
              delay: Math.random() * 5,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>

      <div className="relative z-10 p-6 flex flex-col flex-1">
        {/* Logo */}
        <div className="mb-8 flex items-center justify-center">
          <div className="flex items-center">
            <h1 className="text-3xl font-bold mr-1">TRINGBO</h1>
            <img
              src="/images/logo.svg"
              className="h-[1em] align-middle py-2 mb-2"
              alt="Logo"
              style={{ display: "inline", height: 40 }}
            />
          </div>
        </div>

        {/* Navigation Menu */}
        <nav className="space-y-2">
          {menuItems.map((item, index) => {
            const Icon = item.icon;
            const isActive = currentPage === item.id;

            return (
              <motion.button
                key={item.id}
                onClick={() => onPageChange(item.id)}
                className={`w-full flex items-center space-x-3 px-4 py-3 rounded-xl text-left transition-all duration-300 ${
                  isActive
                    ? "bg-white/20 text-white shadow-lg backdrop-blur-sm"
                    : "text-white/70 hover:text-white hover:bg-white/10"
                }`}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                whileHover={{
                  scale: 1.02,
                  x: 5,
                  boxShadow: isActive
                    ? "0 5px 15px rgba(255,255,255,0.2)"
                    : "none",
                }}
                whileTap={{ scale: 0.98 }}
              >
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  className={`p-2 rounded-lg ${isActive ? "bg-white/20" : ""}`}
                >
                  <Icon className="h-5 w-5" />
                </motion.div>
                <span className="font-medium">{item.label}</span>

                {isActive && (
                  <motion.div
                    layoutId="activeIndicator"
                    className="ml-auto h-2 w-2 rounded-full bg-white"
                    initial={false}
                    transition={{ type: "spring", stiffness: 500, damping: 30 }}
                  />
                )}
              </motion.button>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="mt-auto flex justify-center pt-8">
            <span className="text-sm text-white/70">v{version}</span>
        </div>
      </div>
    </div>
  );
  return SidebarContent;
};

export default Sidebar;
